module.exports = __webpack_public_path__ + "static/media/cpay-logo.3ba91b94.svg";